module.exports = __webpack_public_path__ + "media/images/icons/green-check-circle-510c8d50ea8e19ddbe6daf5c32ae1e3d.svg";